import React, {Component} from 'react';
import Chart from 'chart.js';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

class FunctionBarChart extends Component {
    constructor(props) {
        super(props)
        this.canvasRef = React.createRef();
        this.handleNavigate = this.handleNavigate.bind(this);
    }

    handleNavigate(e) {
        if(this.functionChart.getElementsAtEvent(e)[0]){
        const value = this.functionChart.getElementsAtEvent(e)[0]._model.label;
            this.props.property.history.push(`/view_scenario_catalogue/{"function_mapping":"${this.props.type}_${value}"}`)
        }
    }

    componentDidUpdate() {
        this.functionChart.data.labels = this.props.functionLabel;
        this.functionChart.data.datasets[0].data = this.props.functionValue;
        this.functionChart.update();
        if(this.props.type === 'commercial') {
            this.functionChart.config.data.datasets[0].backgroundColor = "#8FD800"
            this.functionChart.config.data.datasets[0].hoverBackgroundColor = "#757AF7"
            this.functionChart.update()
        } else if (this.props.type === 'passenger') {
            this.functionChart.config.data.datasets[0].backgroundColor = "#757AF7"
            this.functionChart.config.data.datasets[0].hoverBackgroundColor = "#8FD800"
            this.functionChart.update()
        }
    }


    componentDidMount() {
        // let strokeStyle = "#757AF7"
        if(this.props.type === "commercial"){
            // strokeStyle = "#8FD800"
        }
        this.functionChart = new Chart(this.canvasRef.current, {
            type: 'bar',
            options: {
                maintainAspectRatio: false,
                legend: {
                    display: false,
                    onHover: function(){
                    },
                },
                tooltips: {
                    callbacks: {
                        afterLabel: function(t) {
                            let label = parseInt(t.value) * 46656
                            return `Run Achievable : ${label}`;
                        }
                    },
                    scales: {
                        xAxes: [{ barPercentage: 0.5 }]
                    }
                },
                responsive: true,
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                min: 0,
                                fontColor: '#464646',
                                fontWeight: 'bold'
                            },
                            gridLines: {
                                color: "white",
                            }
                        }
                    ], xAxes: [
                        {
                            ticks: {
                                fontColor: '#464646',
                                fontWeight: 'bold'
                            },
                            gridLines: {
                                color: "white",
                            }
                        }
                    ]
                },
                onClick: (e) => { this.handleNavigate(e) }
            },
            data: {
                labels: this.props.functionLabel,
                datasets: [{
                    label: "Base Scenario",
                    data: this.props.functionValue,
                    backgroundColor: "#757AF7",
                    hoverBackgroundColor: "#8FD800"
                }]
            }
        });
    }

    render() {
        return (
            <div>
                <div className="card">
                    <div className="card-body">
                        <h6 style={ this.props.type === 'passenger'?
                            {color: "#757AF7", fontWeight: "bold"}
                            :  { color: "#464646", fontWeight: "bold" }}
                        >
                            Function Mapping
                        </h6>
                        <div>
                            <canvas id="functionChart" style={{ height: "288px", paddingTop: "2%" }} ref={this.canvasRef}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
FunctionBarChart.propTypes={
property:PropTypes.string,
functionLabel:PropTypes.string,
type:PropTypes.string,
functionValue:PropTypes.string,

}
FunctionBarChart.defaultProps= {
property:[],
functionLabel:[],
type:[],
functionValue:[],
}
const mapStateToProps = (state) => {
    return {
        type: state.toggleState.text,
        functionLabel: state.toggleState.functionMappingLabel,
        functionValue: state.toggleState.functionMappingData
    }
}
// componentDidMount() {
//     this.setState( (prevState) => {
//         if(this.props.content){
//             return{
//                 scenario_id: this.props.content.scenario_id,
//                 scenario_group_name: this.props.content.scenario_group_name,
//                 scenario_uuid: this.props.content.scenario_uuid,
//                 scenario_name: this.props.content.scenario_name
//             }
//         } else {
//             return {
//                 scenario_id: "",
//                 scenario_group_name: "",
//                 scenario_uuid: "",
//                 scenario_name: ""
//             }
//         }
//     })
// }

// onScenarioUUIDChange = (e) => {
//     const scenario_uuid = e.target.value;
//     this.setState(() => ({scenario_uuid}));
// }

// onScenarioNameChange = (e) => {
//     const scenario_name = e.target.value;
//     this.setState(() => ({scenario_name}))
// }

// onSubmit = (e) => {
//     e.preventDefault();
//     const submitValue = {
//         scenario_id: this.state.scenario_id,
//         scenario_group_name: this.state.scenario_group_name,
//         scenario_uuid: this.state.scenario_uuid,
//         scenario_name: this.state.scenario_name,
//         scenario_group_scenario_mapping_id: this.props.content.scenario_group_scenario_mapping_id,
//         sequence: this.props.content.sequence,
//         scenario_group_id: this.props.content.scenario_group_id
//     }
//     //console.log(this.state);
// //        updateScenarioGroupDetails(submitValue).then( (response)=> {
// //            console.log(response);
// //        })

//     const edit_api_url = (window.location.origin).concat('/edit')
//     const data_for_api = {
//         scenario_uuid : submitValue['scenario_uuid'],
//         scenario_description : submitValue['scenario_name']
//     }
//     editDb(edit_api_url, data_for_api).then(res => {
//         console.log("Status of updation : ", res['data']['status'])
//         if(res['data']['status'] === "Updated Successfully"){
//             this.props.dispatch(editScenarioGroupData(submitValue));
//             this.props.handleEditModalClose();
//         }

//     })

//     //this.props.dispatch(editScenarioGroupData(submitValue));
//     //this.props.handleEditModalClose();
// };

export default connect(mapStateToProps)(FunctionBarChart)
